import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getData = createAsyncThunk('products/getData', async () => {
    const fetchData = await fetch('https://fakestoreapi.com/products');
    const data = await fetchData.json();
    return data;
});

const initialState = {
    data: [],
    loading: false,
    error: null
};

const productSlice = createSlice({
    name: 'products',
    initialState, 
    extraReducers: (builder) => {
        builder
            .addCase(getData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export default productSlice.reducer;
